var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('el-carousel',{attrs:{"height":"325px"}},_vm._l((_vm.bannerList),function(item,index){return _c('el-carousel-item',{key:index,style:({
        backgroundImage: 'url(' + _vm.picHead + item.picUrl + ')',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center center'
      }),nativeOn:{"click":function($event){return _vm.toList(item.navtypeId)}}},[_c('div',{staticClass:"item"},[_vm._v(" "+_vm._s(item.picTitle)+" ")])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }